import Vue from "vue";
import Regulations from "./Regulations.vue";

export function load() {
  const selector = "Regulations-component";
  // Is the custom Vue root element in the DOM?

  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: (createElement) =>
      createElement(Regulations, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
